export default {
  namespaced: true,
  getters: {
    getItems: (_state, _getters, rootState, rootGetters) => rootGetters['iscsi/targetGroups/getAllTargets']
      .filter(t => rootState.routes.params.nodeId === t.node_id),
    getItemById: (_state, _getters) => id => _getters.getItems.find(item => item.id === id)
  },
  actions: {
    DELETE(store, { item }) {
      return this.dispatch('iscsi/targets/DELETE', { item });
    },
    DELETE_ITEMS(store, { items }) {
      return this.dispatch('iscsi/targets/DELETE_ITEMS', { items });
    },
    FETCH_ITEMS() {
      return this.dispatch('iscsi/targetGroups/FETCH_ITEMS');
    }
  }
};
